const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    lab_id: {
      type: 'string',
      title: 'لابراتوار',
    },
    unit_id: {
      type: 'string',
      title: 'کلینیک',
    },
    role_id: {
      type: 'string',
      title: 'نقش',
    },
  },
});

export default schema;